export { AREA_UNIT_LABELS } from '../../utils/units';
export const DEFAULT_POLYGON_COLOR = '#DC143C';
export const DEFAULT_POLYGON_FILL_OPACITY = 0.3;
